import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/down.png'
import _imports_1 from '../../assets/performance/banner.png'
import _imports_2 from '../../assets/performance/banner4.png'
import _imports_3 from '../../assets/performance/banner_32.jpg'
import _imports_4 from '../../assets/performance/footer.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-56301b29")

_pushScopeId("data-v-56301b29")
const _hoisted_1 = {
  class: "Ecard",
  id: "trendChart"
}
const _hoisted_2 = { class: "testMain" }
const _hoisted_3 = { class: "fitter_title" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, " 删除 ", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 编辑 ")
const _hoisted_6 = { class: "dialog-footer" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("发送报告")
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", null, "按任务生成报告", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("span", null, "手动生成报告", -1)
const _hoisted_13 = {
  class: "versionGeneration1",
  style: {"display":"flex","justify-content":"flex-end","margin-top":"10px"}
}
const _hoisted_14 = { style: {"margin-right":"10px"} }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", null, "生成平均报告", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("span", null, "清除缓存", -1)
const _hoisted_17 = { class: "dialogTitle" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("手动生成报告-按任务")
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "el-icon-message-solid" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode("生成报告")
const _hoisted_21 = { class: "dialogTitle" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("手动生成报告-按任务")
const _hoisted_23 = /*#__PURE__*/_createVNode("i", { class: "el-icon-message-solid" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode("生成报告")
const _hoisted_25 = { class: "dialogTitle" }
const _hoisted_26 = /*#__PURE__*/_createVNode("span", null, "手动生成报告", -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode("生成报告")
const _hoisted_28 = {
  key: 0,
  class: "editRecipient"
}
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" 可按如下任一形式批量添加: ")
const _hoisted_30 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createTextVNode("1、zhangsan;lisi;wangwu ")
const _hoisted_32 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_33 = /*#__PURE__*/_createTextVNode("2、zhangsan(张三);lisi(李四);wangwu(王五) ")
const _hoisted_34 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_35 = /*#__PURE__*/_createTextVNode("3、zhangsan(张三) <zhangsan@tencent.com>;lisi(李四) <lisi@tencent.com>; wangwu(王五) <wangwu@tencent.com> ")
const _hoisted_36 = /*#__PURE__*/_createVNode("span", null, "发送报告", -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_38 = {
  class: "versionGeneration versionGeneration2",
  style: {}
}
const _hoisted_39 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("b")
], -1)
const _hoisted_40 = { class: "copyVal" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode("复制数据")
const _hoisted_42 = { id: "perf_report" }
const _hoisted_43 = {
  key: 0,
  class: "spacName"
}
const _hoisted_44 = /*#__PURE__*/_createVNode("img", {
  class: "banner",
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_45 = {
  key: 1,
  class: "spacName"
}
const _hoisted_46 = /*#__PURE__*/_createVNode("img", {
  class: "banner",
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_47 = {
  key: 2,
  class: "spacName"
}
const _hoisted_48 = /*#__PURE__*/_createVNode("img", {
  class: "banner",
  src: _imports_3,
  alt: ""
}, null, -1)
const _hoisted_49 = { class: "mainContent" }
const _hoisted_50 = { class: "spacName" }
const _hoisted_51 = {
  class: "gameTable",
  style: {"table-layout":"fixed"}
}
const _hoisted_52 = {
  rowspan: 3,
  class: "gameIcon"
}
const _hoisted_53 = {
  colspan: 3,
  class: "game_name"
}
const _hoisted_54 = { width: "200" }
const _hoisted_55 = { class: "d-flex" }
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" 安卓测试版本: ")
const _hoisted_57 = { class: "text-truncate" }
const _hoisted_58 = { width: "200" }
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" 测试时间: ")
const _hoisted_60 = { width: "200" }
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" GM相关: ")
const _hoisted_62 = { class: "d-flex align-items-center" }
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" iOS测试版本: ")
const _hoisted_64 = { class: "text-truncate" }
const _hoisted_65 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createTextVNode(" 测试内容: "),
  /*#__PURE__*/_createVNode("span", null, "主干日构建自动化性能冒烟，5v5对局10真人剧本")
], -1)
const _hoisted_66 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createTextVNode(" 测试服: "),
  /*#__PURE__*/_createVNode("span", null, "AutoTest")
], -1)
const _hoisted_67 = { class: "corePerformance3" }
const _hoisted_68 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("测试结论")
], -1)
const _hoisted_69 = { class: "spacName" }
const _hoisted_70 = { key: 0 }
const _hoisted_71 = { style: {"margin-right":"5px"} }
const _hoisted_72 = { style: {"margin-right":"5px"} }
const _hoisted_73 = { key: 0 }
const _hoisted_74 = { style: {"margin-right":"5px"} }
const _hoisted_75 = { style: {"margin-right":"5px"} }
const _hoisted_76 = { class: "corePerformance" }
const _hoisted_77 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("核心指标")
], -1)
const _hoisted_78 = { class: "spacName" }
const _hoisted_79 = { key: 0 }
const _hoisted_80 = { key: 0 }
const _hoisted_81 = { style: {"size":"14px","font-weight":"bold","padding-bottom":"8px"} }
const _hoisted_82 = {
  key: 0,
  style: {"margin":"20px 0"}
}
const _hoisted_83 = { class: "labelStyle" }
const _hoisted_84 = /*#__PURE__*/_createVNode("span", { class: "labelStyle2" }, "     场景:5v5真人剧本", -1)
const _hoisted_85 = { class: "corePerformance" }
const _hoisted_86 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("自动化路径图")
], -1)
const _hoisted_87 = { class: "spacName" }
const _hoisted_88 = {
  key: 0,
  class: "detailedTest"
}
const _hoisted_89 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("详细测试数据")
], -1)
const _hoisted_90 = { class: "describe" }
const _hoisted_91 = /*#__PURE__*/_createVNode("span", null, "灰色", -1)
const _hoisted_92 = { class: "spacName2" }
const _hoisted_93 = { class: "open" }
const _hoisted_94 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, "序列"),
    /*#__PURE__*/_createVNode("td", null, "测试用例"),
    /*#__PURE__*/_createVNode("td", null, "链接")
  ])
], -1)
const _hoisted_95 = { key: 0 }
const _hoisted_96 = /*#__PURE__*/_createVNode("td", null, "1", -1)
const _hoisted_97 = /*#__PURE__*/_createVNode("td", null, "开profiler", -1)
const _hoisted_98 = /*#__PURE__*/_createVNode("td", null, "关profiler", -1)
const _hoisted_99 = {
  key: 0,
  class: "spacName2"
}
const _hoisted_100 = /*#__PURE__*/_createVNode("h5", null, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆"),
  /*#__PURE__*/_createTextVNode(" 关键场景截图 ")
], -1)
const _hoisted_101 = { style: {"padding":"0","display":"flex","flex-wrap":"wrap"} }
const _hoisted_102 = { style: {"border-collapse":"collapse"} }
const _hoisted_103 = { style: {"background":"#f5f7fa","border":"1px solid #e2e7eb","padding":"5px"} }
const _hoisted_104 = { style: {"border":"1px solid #e2e7eb"} }
const _hoisted_105 = { class: "dialog-footer" }
const _hoisted_106 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_107 = /*#__PURE__*/_createTextVNode(" 确认 ")
const _hoisted_108 = { class: "spacName" }
const _hoisted_109 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("测试说明")
], -1)
const _hoisted_110 = {
  key: 0,
  class: "textMargin"
}
const _hoisted_111 = /*#__PURE__*/_createVNode("div", { style: {"font-weight":"bolder","padding-bottom":"10px"} }, " 1、GM相关说明 ", -1)
const _hoisted_112 = /*#__PURE__*/_createVNode("p", { class: "test_table" }, " ①使用GM FinishSchool、FinishLevel跳过新手引导。 ", -1)
const _hoisted_113 = /*#__PURE__*/_createVNode("p", { class: "test_table" }, " ②使用GM NewbieKnowledge,10,0,0,0,0,0，屏蔽局内新手引导相关UI。 ", -1)
const _hoisted_114 = {
  key: 0,
  class: "test_table"
}
const _hoisted_115 = { key: 1 }
const _hoisted_116 = /*#__PURE__*/_createVNode("div", { style: {"font-weight":"bolder","padding-bottom":"10px"} }, " 2、开profiler版本的相关性能文件自动上传至SVN路径: ", -1)
const _hoisted_117 = /*#__PURE__*/_createVNode("span", { class: "test_table" }, "http://svn-cd1.tencent.com/SGameA/SGame_proj/branches/VersionBranch_v71_AutoPerformance_20210819/LMsgProfilerData/十真人自动化测试", -1)
const _hoisted_118 = { class: "textMargin" }
const _hoisted_119 = { style: {"font-weight":"bolder","padding":"10px 0"} }
const _hoisted_120 = /*#__PURE__*/_createVNode("p", { class: "test_table" }, [
  /*#__PURE__*/_createVNode("span", { id: "triangle-right" }),
  /*#__PURE__*/_createTextVNode("手机测试前:电量充满，手机温度冷却，重启手机，关闭其他后台应用 ")
], -1)
const _hoisted_121 = /*#__PURE__*/_createVNode("p", { class: "test_table" }, [
  /*#__PURE__*/_createVNode("span", { id: "triangle-right" }),
  /*#__PURE__*/_createTextVNode("测试时间:18min左右 ")
], -1)
const _hoisted_122 = /*#__PURE__*/_createVNode("p", { class: "test_table" }, [
  /*#__PURE__*/_createVNode("span", { id: "triangle-right" }),
  /*#__PURE__*/_createTextVNode("5V5对战固定英雄: ")
], -1)
const _hoisted_123 = {
  key: 0,
  class: "box test_table",
  style: {"display":"flex","margin-bottom":"10px"}
}
const _hoisted_124 = /*#__PURE__*/_createVNode("div", { style: {"text-indent":"24px"} }, [
  /*#__PURE__*/_createVNode("div", null, [
    /*#__PURE__*/_createVNode("span", { style: {"display":"inline-block","height":"15px","width":"15px","background":"blue","margin-right":"5px"} }),
    /*#__PURE__*/_createTextVNode("蓝色方: ")
  ]),
  /*#__PURE__*/_createVNode("div", null, [
    /*#__PURE__*/_createVNode("span", { style: {"display":"inline-block","height":"15px","width":"15px","background":"red","margin-right":"5px"} }),
    /*#__PURE__*/_createTextVNode("红色方: ")
  ])
], -1)
const _hoisted_125 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("div", null, "欧米茄/刘禅（对抗）"),
  /*#__PURE__*/_createVNode("div", null, "薇菈/妲己（中路）")
], -1)
const _hoisted_126 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("div", null, "克里希/小乔（中路）"),
  /*#__PURE__*/_createVNode("div", null, "莫托斯/亚瑟（打野）")
], -1)
const _hoisted_127 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("div", null, "瑟斐斯/赵云（打野）"),
  /*#__PURE__*/_createVNode("div", null, "卡莉/孙尚香（射手）")
], -1)
const _hoisted_128 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("div", null, "哥德尔/墨子（辅助）"),
  /*#__PURE__*/_createVNode("div", null, "查戈纳尔/庄周（辅助）")
], -1)
const _hoisted_129 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("div", null, "勇/鲁班七号（射手）"),
  /*#__PURE__*/_createVNode("div", null, "穆加爵/扁鹊（对抗）")
], -1)
const _hoisted_130 = {
  key: 1,
  class: "box test_table",
  style: {"display":"flex","margin-bottom":"10px"}
}
const _hoisted_131 = /*#__PURE__*/_createVNode("div", { style: {"text-indent":"24px"} }, [
  /*#__PURE__*/_createVNode("div", null, [
    /*#__PURE__*/_createVNode("span", { style: {"display":"inline-block","height":"15px","width":"15px","background":"blue","margin-right":"5px"} }),
    /*#__PURE__*/_createTextVNode("蓝色方: ")
  ]),
  /*#__PURE__*/_createVNode("div", null, [
    /*#__PURE__*/_createVNode("span", { style: {"display":"inline-block","height":"15px","width":"15px","background":"red","margin-right":"5px"} }),
    /*#__PURE__*/_createTextVNode("红色方: ")
  ])
], -1)
const _hoisted_132 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("div", null, "夏侯惇(对抗)"),
  /*#__PURE__*/_createVNode("div", null, "妲己(中路)")
], -1)
const _hoisted_133 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("div", null, "小乔(中路)"),
  /*#__PURE__*/_createVNode("div", null, "亚瑟(打野)")
], -1)
const _hoisted_134 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("div", null, "赵云(打野)"),
  /*#__PURE__*/_createVNode("div", null, "孙尚香(射手)")
], -1)
const _hoisted_135 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("div", null, "墨子(辅助)"),
  /*#__PURE__*/_createVNode("div", null, "庄周(辅助)")
], -1)
const _hoisted_136 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("div", null, "鲁班七号(射手)"),
  /*#__PURE__*/_createVNode("div", null, "扁鹊(对抗)")
], -1)
const _hoisted_137 = /*#__PURE__*/_createVNode("p", { class: "test_table" }, [
  /*#__PURE__*/_createVNode("span", { id: "triangle-right" }),
  /*#__PURE__*/_createTextVNode("英雄行为: ")
], -1)
const _hoisted_138 = { style: {"font-weight":"bolder","padding":"10px 0"} }
const _hoisted_139 = {
  style: {"text-align":"left"},
  class: "gameTable4"
}
const _hoisted_140 = { style: {"text-align":"left","box-sizing":"border-box","padding":"0 10px"} }
const _hoisted_141 = {
  key: 0,
  style: {"margin-left":"13px"}
}
const _hoisted_142 = { style: {"text-align":"left","box-sizing":"border-box","padding":"0 10px"} }
const _hoisted_143 = {
  key: 0,
  style: {"margin-left":"13px"}
}
const _hoisted_144 = /*#__PURE__*/_createVNode("div", { class: "footer" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_4,
    alt: ""
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, [
                  _createVNode(_component_el_form, {
                    inline: true,
                    model: _ctx.filterList,
                    size: "mini"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, { label: "选择日期" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.filterList.pick,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterList.pick = $event)),
                            type: "date",
                            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.date('pick'))),
                            placeholder: "请选择时间",
                            size: _ctx.size
                          }, null, 8, ["modelValue", "size"])
                        ]),
                        _: 1
                      }),
                      (_ctx.versionShow)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            class: "iTemWidth3",
                            label: "测试任务"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                filterable: "",
                                modelValue: _ctx.filterList.version,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filterList.version = $event)),
                                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.date('version'))),
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.RecentTaskList, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.task_id,
                                      label: item.task_name,
                                      value: item.task_id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_form_item, {
                        class: "reportName",
                        label: "报告类型"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            filterable: "",
                            onChange: _ctx.date,
                            size: "mini",
                            modelValue: _ctx.filterList.subType,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.filterList.subType = $event)),
                            id: "new_version",
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subTypeList1, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["onChange", "modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model"]),
                  _createVNode("div", _hoisted_3, [
                    _createVNode(_component_el_form, {
                      inline: true,
                      size: "mini",
                      class: "spacForm queryReport"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, { label: "报告名称" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.name_search,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.name_search = $event)),
                              placeholder: "请选择",
                              onChange: _ctx.change_name_search
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.nameList, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.id,
                                    label: 
                        item.report_name +
                        '-[' +
                        item.create_date.replace('T', ' ') +
                        ']'
                      ,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, null, {
                          default: _withId(() => [
                            _createVNode(_component_el_popconfirm, {
                              onConfirm: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleDelete())),
                              title: "确认删除该报告？",
                              placement: "top"
                            }, {
                              reference: _withId(() => [
                                _createVNode(_component_el_button, {
                                  size: "mini",
                                  type: "info",
                                  disabled: _ctx.get_is_super
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "暂无管理员权限",
                                      placement: "top",
                                      disabled: !_ctx.get_is_super
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_4
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              class: "editBtn",
                              size: "mini",
                              onClick: _ctx.handleEdit
                            }, {
                              default: _withId(() => [
                                _hoisted_5
                              ]),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(_component_el_dialog, {
                              modelValue: _ctx.dialogFormVisible1,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.dialogFormVisible1 = $event))
                            }, {
                              footer: _withId(() => [
                                _createVNode("span", _hoisted_6, [
                                  _createVNode(_component_el_button, {
                                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.dialogFormVisible1 = false))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_7
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    onClick: _ctx.dialogFormVisible2
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_8
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ])
                              ]),
                              default: _withId(() => [
                                _withDirectives(_createVNode(_component_el_form, {
                                  class: "demo-form-inline",
                                  inline: true
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_form_item, {
                                      class: "reportName",
                                      label: "报告名称"
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_input, {
                                          size: "small",
                                          class: "report-input",
                                          modelValue: _ctx.form1.name,
                                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form1.name = $event)),
                                          autocomplete: "off",
                                          width: "500"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      class: "reportName",
                                      label: "报告类型"
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_select, {
                                          size: "small",
                                          modelValue: _ctx.form1.type,
                                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form1.type = $event)),
                                          id: "new_version",
                                          placeholder: "请选择",
                                          "collapse-tags": "",
                                          "collapse-tags-tooltip": ""
                                        }, {
                                          default: _withId(() => [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subTypeList1, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item.value,
                                                label: item.label,
                                                value: item.value
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 512), [
                                  [_vShow, _ctx.dialogFormVisible1]
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _ctx.sendOut,
                              class: "down_img"
                            }, {
                              default: _withId(() => [
                                _hoisted_9,
                                _hoisted_10
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode("div", null, [
                      _createVNode(_component_el_button, {
                        size: "mini",
                        type: "primary",
                        onClick: _ctx.generateReportsManuallyByTask,
                        disabled: _ctx.get_is_super,
                        style: {"height":"28px"}
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_tooltip, {
                            effect: "dark",
                            content: "暂无管理员权限",
                            placement: "top",
                            disabled: !_ctx.get_is_super
                          }, {
                            default: _withId(() => [
                              _hoisted_11
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"]),
                      _createVNode(_component_el_button, {
                        size: "mini",
                        type: "primary",
                        onClick: _ctx.generateReportsManually,
                        disabled: _ctx.get_is_super,
                        style: {"height":"28px"}
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_tooltip, {
                            effect: "dark",
                            content: "暂无管理员权限",
                            placement: "top",
                            disabled: !_ctx.get_is_super
                          }, {
                            default: _withId(() => [
                              _hoisted_12
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_13, [
                    _createVNode("div", _hoisted_14, [
                      _createVNode(_component_el_button, {
                        size: "mini",
                        type: "primary",
                        onClick: _ctx.generateReportsManuallyByTask1,
                        style: {"height":"28px"}
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_tooltip, {
                            effect: "dark",
                            content: "暂无管理员权限",
                            placement: "top",
                            disabled: !_ctx.get_is_super
                          }, {
                            default: _withId(() => [
                              _hoisted_15
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _createVNode(_component_el_button, {
                      size: "mini",
                      type: "primary",
                      onClick: _ctx.clear,
                      disabled: _ctx.get_is_super,
                      style: {"height":"28px"}
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_tooltip, {
                          effect: "dark",
                          content: "暂无管理员权限",
                          placement: "top",
                          disabled: !_ctx.get_is_super
                        }, {
                          default: _withId(() => [
                            _hoisted_16
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    }, 8, ["onClick", "disabled"])
                  ]),
                  _createVNode(_component_el_dialog, {
                    modelValue: _ctx.dialogFormVisibleByTask,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.dialogFormVisibleByTask = $event)),
                    width: "790px"
                  }, {
                    title: _withId(() => [
                      _createVNode("div", _hoisted_17, [
                        _createVNode("span", null, [
                          _hoisted_18,
                          _createVNode(_component_el_tooltip, {
                            class: "item",
                            effect: "dark",
                            content: "如只选择测试任务, 则按照任务完成自动生成报告的逻辑生成一份报告",
                            placement: "top"
                          }, {
                            default: _withId(() => [
                              _hoisted_19
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode(_component_el_divider)
                      ])
                    ]),
                    footer: _withId(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.generateReportByTask,
                        size: "small"
                      }, {
                        default: _withId(() => [
                          _hoisted_20
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    default: _withId(() => [
                      _createVNode(_component_el_form, {
                        inline: true,
                        model: _ctx.generateReportVersion,
                        "label-position": "top",
                        size: "small"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "对比任务" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.oldEdition1,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.generateReportVersion.oldEdition1 = $event)),
                                id: "old_version",
                                placeholder: "请选择",
                                "collapse-tags": "",
                                "collapse-tags-tooltip": "",
                                multiple: ""
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.RecentTaskrecord, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "测试任务" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.newEdition1,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.generateReportVersion.newEdition1 = $event)),
                                id: "new_version",
                                placeholder: "请选择",
                                "collapse-tags": "",
                                "collapse-tags-tooltip": "",
                                multiple: ""
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.RecentTaskrecord, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "平均值" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_checkbox, {
                                modelValue: _ctx.generateReportVersion.is_avg,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.generateReportVersion.is_avg = $event)),
                                size: "large"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _withDirectives(_createVNode(_component_el_form_item, { label: "报告类型" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.subType,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.generateReportVersion.subType = $event)),
                                id: "subType",
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subTypeList, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, false]
                          ])
                        ]),
                        _: 1
                      }, 8, ["model"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_dialog, {
                    modelValue: _ctx.dialogFormVisibleByTask1,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.dialogFormVisibleByTask1 = $event)),
                    width: "790px"
                  }, {
                    title: _withId(() => [
                      _createVNode("div", _hoisted_21, [
                        _createVNode("span", null, [
                          _hoisted_22,
                          _createVNode(_component_el_tooltip, {
                            class: "item",
                            effect: "dark",
                            content: "如只选择测试任务, 则按照任务完成自动生成报告的逻辑生成一份报告",
                            placement: "top"
                          }, {
                            default: _withId(() => [
                              _hoisted_23
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode(_component_el_divider)
                      ])
                    ]),
                    footer: _withId(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.generateReportByTask1,
                        size: "small"
                      }, {
                        default: _withId(() => [
                          _hoisted_24
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    default: _withId(() => [
                      _createVNode(_component_el_form, {
                        inline: true,
                        model: _ctx.generateReportVersion,
                        "label-position": "top",
                        size: "small"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "测试任务" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.newEdition2,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.generateReportVersion.newEdition2 = $event)),
                                id: "new_version",
                                placeholder: "请选择",
                                "collapse-tags": "",
                                "collapse-tags-tooltip": "",
                                multiple: ""
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.RecentTaskrecord, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _withDirectives(_createVNode(_component_el_form_item, { label: "报告类型" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.subType,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.generateReportVersion.subType = $event)),
                                id: "subType",
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subTypeList, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, false]
                          ])
                        ]),
                        _: 1
                      }, 8, ["model"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_dialog, {
                    modelValue: _ctx.dialogFormVisible,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.dialogFormVisible = $event)),
                    width: "790px"
                  }, {
                    title: _withId(() => [
                      _createVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _createVNode(_component_el_divider)
                      ])
                    ]),
                    footer: _withId(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.generateReport,
                        size: "small"
                      }, {
                        default: _withId(() => [
                          _hoisted_27
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    default: _withId(() => [
                      _createVNode(_component_el_form, {
                        inline: true,
                        model: _ctx.generateReportVersion,
                        "label-position": "top",
                        size: "small"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "旧版本" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.oldEdition,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.generateReportVersion.oldEdition = $event)),
                                id: "old_version",
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.game_version_options, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "新版本" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.newEdition,
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.generateReportVersion.newEdition = $event)),
                                id: "new_version",
                                placeholder: "请选择",
                                onChange: _ctx.selectVersion
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.game_version_options, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onChange"])
                            ]),
                            _: 1
                          }),
                          _withDirectives(_createVNode(_component_el_form_item, { label: "场景" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.scenetion,
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.generateReportVersion.scenetion = $event)),
                                multiple: "",
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.game_scene_version, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.scene_id_id,
                                      label: item.scene_id__chinese,
                                      value: item.scene_id_id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, _ctx.localProject != 34 && _ctx.localProject != 40]
                          ]),
                          _createVNode(_component_el_form_item, { label: "报告类型" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.subType,
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.generateReportVersion.subType = $event)),
                                id: "subType",
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subTypeList, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  (_ctx.edit)
                    ? (_openBlock(), _createBlock("div", _hoisted_28, [
                        _createVNode(_component_el_form, {
                          "label-position": "left",
                          "label-width": "100px",
                          model: _ctx.formMail,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "邮件标题" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.title,
                                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.formMail.title = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件发件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _createTextVNode(" 指定的邮件发件人需要位于公司TOF发件人名单,否则无法发送邮件。默认邮件发件人" + _toDisplayString(_ctx.formMail.Sender), 1)
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.Sender,
                                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.formMail.Sender = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件收件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _hoisted_29,
                                    _hoisted_30,
                                    _hoisted_31,
                                    _hoisted_32,
                                    _hoisted_33,
                                    _hoisted_34,
                                    _hoisted_35
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.addressee,
                                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.formMail.addressee = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件抄送人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.CC_List,
                                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.formMail.CC_List = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_popconfirm, {
                              title: "确认发送报告吗？",
                              onConfirm: _cache[29] || (_cache[29] = ($event: any) => (_ctx.save_report(false))),
                              placement: "top"
                            }, {
                              reference: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  disabled: _ctx.get_is_super,
                                  size: "mini"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "暂无管理员权限",
                                      placement: "top",
                                      disabled: !_ctx.get_is_super
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_36
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              size: "mini",
                              type: "info",
                              onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.edit = false))
                            }, {
                              default: _withId(() => [
                                _hoisted_37
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["model"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_38, [
                    _hoisted_39,
                    _createVNode("div", _hoisted_40, [
                      (
                    !_ctx.get_is_super &&
                    (_ctx.localProject === 34 ||
                      _ctx.localProject === 12 ||
                      _ctx.localProject === 32 ||
                      _ctx.localProject === 47 ||
                      _ctx.localProject === 35 ||
                      _ctx.localProject === 9 ||
                      _ctx.localProject === 36 ||
                      _ctx.localProject === 40)
                  )
                        ? (_openBlock(), _createBlock(_component_el_form, {
                            key: 0,
                            inline: true,
                            model: _ctx.copyVal,
                            size: "mini"
                          }, {
                            default: _withId(() => [
                              (_ctx.new_report.task_record_id != null)
                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                    key: 0,
                                    label: "当前记录id:",
                                    class: "iTemWidth2"
                                  }, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(_ctx.new_report.task_record_id), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_el_form_item, {
                                label: "任务记录id",
                                class: "iTemWidth"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    onChange: _ctx.equipmentUpdate,
                                    modelValue: _ctx.copyVal.taskRecordId,
                                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.copyVal.taskRecordId = $event)),
                                    placeholder: "请选择任务记录id",
                                    filterable: ""
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.TaskRecordQuery, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.id,
                                          label: item.id,
                                          value: item.id
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["onChange", "modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, {
                                label: "设备数据",
                                class: "iTemWidth"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.copyVal.deviceVal,
                                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.copyVal.deviceVal = $event)),
                                    placeholder: "请选择设备数据",
                                    filterable: ""
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.TaskRecordDevices, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.id,
                                          label: item.model.model,
                                          value: item.id
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, null, {
                                default: _withId(() => [
                                  _createVNode(_component_el_popconfirm, {
                                    title: "确认复制数据吗？",
                                    onConfirm: _ctx.CopyBtn,
                                    placement: "top"
                                  }, {
                                    reference: _withId(() => [
                                      _createVNode(_component_el_button, {
                                        type: "primary",
                                        disabled: _ctx.interfaceDisabled
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_41
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"])
                                    ]),
                                    _: 1
                                  }, 8, ["onConfirm"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["model"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("div", _hoisted_42, [
                    (
                  _ctx.localProject !== 34 &&
                  _ctx.localProject !== 40 &&
                  _ctx.localProject !== 32 &&
                  _ctx.localProject !== 47
                )
                      ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_43, [
                          _hoisted_44
                        ], 512)), [
                          [_directive_loading, _ctx.loading]
                        ])
                      : _createCommentVNode("", true),
                    (
                  _ctx.localProject === 34 ||
                  _ctx.localProject === 40 ||
                  _ctx.localProject === 47
                )
                      ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_45, [
                          _hoisted_46
                        ], 512)), [
                          [_directive_loading, _ctx.loading]
                        ])
                      : _createCommentVNode("", true),
                    (_ctx.localProject === 32)
                      ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_47, [
                          _hoisted_48
                        ], 512)), [
                          [_directive_loading, _ctx.loading]
                        ])
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_49, [
                      _createVNode("div", _hoisted_50, [
                        _withDirectives(_createVNode("table", _hoisted_51, [
                          _createVNode("tr", null, [
                            _createVNode("td", _hoisted_52, [
                              _createVNode("img", {
                                src: _ctx.get_core_data.project.icon
                              }, null, 8, ["src"])
                            ]),
                            _createVNode("td", _hoisted_53, " 【" + _toDisplayString(_ctx.get_core_data.project.project_name) + "】 ", 1)
                          ]),
                          _createVNode("tr", null, [
                            _createVNode("td", _hoisted_54, [
                              _createVNode("div", _hoisted_55, [
                                _hoisted_56,
                                _createVNode("span", _hoisted_57, [
                                  (_ctx.localProject == 18)
                                    ? (_openBlock(), _createBlock("span", {
                                        key: 0,
                                        title: _ctx.get_core_data?.able_versions?.android_new_version,
                                        class: ""
                                      }, _toDisplayString(_ctx.get_core_data?.able_versions?.android_new_version), 9, ["title"]))
                                    : (_openBlock(), _createBlock("a", {
                                        key: 1,
                                        target: "_blank",
                                        href: _ctx.get_core_data.pkg_name?.url,
                                        title: _ctx.get_core_data.pkg_name?.android
                                      }, _toDisplayString(_ctx.get_core_data.pkg_name?.android), 9, ["href", "title"]))
                                ])
                              ])
                            ]),
                            _createVNode("td", _hoisted_58, [
                              _hoisted_59,
                              _createVNode("span", null, _toDisplayString(_ctx.get_core_data.data), 1)
                            ]),
                            _createVNode("td", _hoisted_60, [
                              _hoisted_61,
                              _createVNode("span", null, _toDisplayString(_ctx.get_core_data.report_type), 1)
                            ])
                          ]),
                          _createVNode("tr", null, [
                            _createVNode("td", _hoisted_62, [
                              _hoisted_63,
                              _createVNode("span", _hoisted_64, [
                                (_ctx.localProject == 18)
                                  ? (_openBlock(), _createBlock("span", {
                                      key: 0,
                                      title: _ctx.get_core_data?.able_versions?.ios_new_version
                                    }, _toDisplayString(_ctx.get_core_data?.able_versions?.ios_new_version), 9, ["title"]))
                                  : (_openBlock(), _createBlock("a", {
                                      key: 1,
                                      target: "_blank",
                                      href: _ctx.get_core_data.pkg_name?.ios_url,
                                      title: _ctx.get_core_data.pkg_name?.ios
                                    }, _toDisplayString(_ctx.get_core_data.pkg_name?.ios), 9, ["href", "title"]))
                              ])
                            ]),
                            _hoisted_65,
                            _hoisted_66
                          ])
                        ], 512), [
                          [_directive_loading, _ctx.loading]
                        ])
                      ]),
                      _withDirectives(_createVNode("div", _hoisted_67, [
                        _hoisted_68,
                        _createVNode("div", _hoisted_69, [
                          _createVNode(_component_el_table, {
                            data: _ctx.testConclusion,
                            border: ""
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_table_column, {
                                prop: "name",
                                label: "性能指标",
                                width: "200",
                                align: "center"
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "android",
                                label: "明显变化 &低端机数据(安卓)",
                                align: "left"
                              }, {
                                default: _withId((scope) => [
                                  (scope.row?.android?.length == 0)
                                    ? (_openBlock(), _createBlock("span", _hoisted_70, "各机型变化不大"))
                                    : (
                              scope.row?.android1 != undefined &&
                              scope.row?.android?.length != 0
                            )
                                      ? (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(scope.row?.android1, (item, index) => {
                                          return (_openBlock(), _createBlock("div", { key: index }, [
                                            _createVNode("span", _hoisted_71, _toDisplayString(index + 1 + "."), 1),
                                            _createTextVNode(_toDisplayString(_ctx.getColor(item)), 1),
                                            _createVNode("span", {
                                              style: 'color:' + _ctx.com1(_ctx.getColor1(item))
                                            }, _toDisplayString(_ctx.getColor1(item)), 5),
                                            _createVNode("span", null, _toDisplayString(_ctx.getColor1(item) == "" ? "" : ")"), 1)
                                          ]))
                                        }), 128))
                                      : (
                              scope.row?.android1 == undefined &&
                              scope.row?.android?.length != 0
                            )
                                        ? (_openBlock(true), _createBlock(_Fragment, { key: 2 }, _renderList(scope.row?.android, (j, i) => {
                                            return (_openBlock(), _createBlock("div", { key: i }, [
                                              _createVNode("span", _hoisted_72, _toDisplayString(i + 1 + "."), 1),
                                              _createTextVNode(_toDisplayString(_ctx.getColor(j)), 1),
                                              _createVNode("span", {
                                                style: 'color:' + _ctx.com(_ctx.getColor1(j))
                                              }, _toDisplayString(_ctx.getColor1(j)), 5),
                                              _createVNode("span", null, _toDisplayString(_ctx.getColor1(j) == "" ? "" : ")"), 1)
                                            ]))
                                          }), 128))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "ios",
                                align: "left",
                                label: "明显变化 &低端机数据(iOS)"
                              }, {
                                default: _withId((scope) => [
                                  (scope.row?.ios?.length == 0)
                                    ? (_openBlock(), _createBlock("span", _hoisted_73, "各机型变化不大"))
                                    : (
                              scope.row?.ios1 != undefined &&
                              scope.row?.ios?.length != 0
                            )
                                      ? (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(scope.row?.ios1, (item, index) => {
                                          return (_openBlock(), _createBlock("div", { key: index }, [
                                            _createVNode("span", _hoisted_74, _toDisplayString(index + 1 + "."), 1),
                                            _createTextVNode(_toDisplayString(_ctx.getColor(item)), 1),
                                            _createVNode("span", {
                                              style: 'color:' + _ctx.com1(_ctx.getColor1(item))
                                            }, _toDisplayString(_ctx.getColor1(item)), 5),
                                            _createVNode("span", null, _toDisplayString(_ctx.getColor1(item) == "" ? "" : ")"), 1)
                                          ]))
                                        }), 128))
                                      : (
                              scope.row?.ios1 == undefined &&
                              scope.row?.ios?.length != 0
                            )
                                        ? (_openBlock(true), _createBlock(_Fragment, { key: 2 }, _renderList(scope.row?.ios, (j, i) => {
                                            return (_openBlock(), _createBlock("div", { key: i }, [
                                              _createVNode("span", _hoisted_75, _toDisplayString(i + 1 + "."), 1),
                                              _createTextVNode(_toDisplayString(_ctx.getColor(j)), 1),
                                              _createVNode("span", {
                                                style: 'color:' + _ctx.com(_ctx.getColor1(j))
                                              }, _toDisplayString(_ctx.getColor1(j)), 5),
                                              _createVNode("span", null, _toDisplayString(_ctx.getColor1(j) == "" ? "" : ")"), 1)
                                            ]))
                                          }), 128))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["data"])
                        ])
                      ], 512), [
                        [_directive_loading, _ctx.loading]
                      ]),
                      _withDirectives(_createVNode("div", _hoisted_76, [
                        _hoisted_77,
                        _createVNode("div", _hoisted_78, [
                          (_ctx.ecShow)
                            ? (_openBlock(), _createBlock("div", _hoisted_79, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.corePerformance, (item) => {
                                  return (_openBlock(), _createBlock(_Fragment, {
                                    key: item.title
                                  }, [
                                    (_ctx.corePerformance.length > 1)
                                      ? (_openBlock(), _createBlock("h6", _hoisted_80, _toDisplayString(item.title), 1))
                                      : _createCommentVNode("", true),
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataTable, (setting) => {
                                      return (_openBlock(), _createBlock("div", { key: setting }, [
                                        _createVNode("div", _hoisted_81, _toDisplayString(_ctx.get_field(setting)), 1),
                                        _createVNode(_component_el_table, {
                                          data: _ctx.getData(setting, item.data),
                                          "span-method": _ctx.objectSpanMethod
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_table_column, {
                                              prop: "scene",
                                              label: "测试场景"
                                            }, {
                                              default: _withId((scope) => [
                                                _createVNode("span", null, _toDisplayString(scope.row?.scene), 1)
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_el_table_column, {
                                              label: 
                                _ctx.get_field(setting) +
                                '趋势(vs. ' +
                                _ctx.old_text() +
                                ')'
                              
                                            }, {
                                              default: _withId(() => [
                                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.compare, (device, index) => {
                                                  return (_openBlock(), _createBlock(_component_el_table_column, {
                                                    key: Number(index),
                                                    label: device
                                                  }, {
                                                    default: _withId((scope) => [
                                                      _createVNode(_component_el_tooltip, {
                                                        effect: "dark",
                                                        placement: "top"
                                                      }, {
                                                        content: _withId(() => [
                                                          _createVNode("span", null, _toDisplayString(scope.row.new[index]?.data
                                            ?.game_version || "--") + " 对比 " + _toDisplayString(scope.row.old[index]?.data
                                            ?.game_version || "--"), 1)
                                                        ]),
                                                        default: _withId(() => [
                                                          _createVNode("span", {
                                                            onClick: ($event: any) => (
                                        _ctx.target(scope.row.new[index].data?.url)
                                      ),
                                                            style: 
                                        _ctx.compore_num(
                                          scope.row.new[index]?.data?.[setting],
                                          scope.row.old[index]?.data?.[setting],
                                          setting,
                                          scope.row,
                                          scope.row.new[index]
                                        )[3] + ';cursor:pointer'
                                      
                                                          }, _toDisplayString(scope.row.new[index]?.data?.[setting] ||
                                        "--"), 13, ["onClick"])
                                                        ]),
                                                        _: 2
                                                      }, 1024),
                                                      (
                                      _ctx.compore_num(
                                        scope.row.new[index]?.data?.[setting],
                                        scope.row.old[index]?.data?.[setting],
                                        setting,
                                        scope.row,
                                        scope.row.new[index]
                                      )[0] !== ''
                                    )
                                                        ? (_openBlock(), _createBlock("span", {
                                                            key: 0,
                                                            id: "blodTypeId",
                                                            style: 
                                      'color:' +
                                      _ctx.compore_num(
                                        scope.row.new[index]?.data?.[setting],
                                        scope.row.old[index]?.data?.[setting],
                                        setting,
                                        scope.row,
                                        scope.row.new[index]
                                      )[2]
                                    
                                                          }, _toDisplayString(_ctx.compore_num(
                                        scope.row.new[index]?.data?.[setting],
                                        scope.row.old[index]?.data?.[setting],
                                        setting,
                                        scope.row,
                                        scope.row.new[index]
                                      )[0]), 5))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["label"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1032, ["label"])
                                          ]),
                                          _: 2
                                        }, 1032, ["data", "span-method"]),
                                        (_ctx.ecShow)
                                          ? (_openBlock(), _createBlock("div", _hoisted_82, [
                                              _withDirectives(_createVNode(_component_el_card, null, {
                                                default: _withId(() => [
                                                  _createVNode("p", null, [
                                                    _createVNode("span", _hoisted_83, _toDisplayString(_ctx.get_field(setting)) + "趋势图", 1),
                                                    _hoisted_84
                                                  ]),
                                                  _createVNode("div", {
                                                    ref: 'performance_line' + setting,
                                                    class: "echartHeight",
                                                    style: {"width":"100%","height":"350px"}
                                                  }, null, 512)
                                                ]),
                                                _: 2
                                              }, 1536), [
                                                [_directive_loading, _ctx.line_loading]
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128))
                                  ], 64))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ], 512), [
                        [_directive_loading, _ctx.loading]
                      ]),
                      _withDirectives(_createVNode("div", _hoisted_85, [
                        _hoisted_86,
                        _createVNode("div", null, [
                          _createVNode(_component_el_form, { inline: true }, {
                            default: _withId(() => [
                              _createVNode(_component_el_form_item, { label: "选择场景" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.selected_scene1,
                                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.selected_scene1 = $event)),
                                    size: "mini",
                                    filterable: "",
                                    placeholder: "请选择场景",
                                    onChange: _ctx.selectSceneChange1
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_options1, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.scene_id,
                                          label: item.chinese,
                                          value: item.scene_id
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "onChange"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode("div", _hoisted_87, [
                          _createVNode(_component_el_table, {
                            data: _ctx.imgData,
                            border: ""
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_table_column, {
                                prop: "device_name",
                                label: "测试机型",
                                width: "150"
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "trajectory",
                                label: "自动化路径图"
                              }, {
                                default: _withId((scope) => [
                                  _createVNode(_component_el_image, {
                                    style: {"width":"100%","height":"100%"},
                                    src: scope.row.trajectory
                                  }, null, 8, ["src"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "fps",
                                label: "FPS热力图"
                              }, {
                                default: _withId((scope) => [
                                  _createVNode(_component_el_image, {
                                    style: {"width":"100%","height":"100%"},
                                    src: scope.row.fps
                                  }, null, 8, ["src"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["data"])
                        ])
                      ], 512), [
                        [_directive_loading, _ctx.loading],
                        [_vShow, _ctx.localProject === 12]
                      ]),
                      (_ctx.localProject != 18)
                        ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_88, [
                            _hoisted_89,
                            _createVNode("p", _hoisted_90, [
                              _hoisted_91,
                              _createTextVNode("为上个版本数据，白色为当前内网最新版本数据。  当前版本:" + _toDisplayString(_ctx.get_core_data.able_versions.android_new_version) + "  对比版本: " + _toDisplayString(_ctx.old_text()), 1)
                            ]),
                            _createVNode("div", _hoisted_92, [
                              _createVNode("table", _hoisted_93, [
                                _hoisted_94,
                                _createVNode("tbody", null, [
                                  (_ctx.localProject !== 32)
                                    ? (_openBlock(), _createBlock("tr", _hoisted_95, [
                                        _hoisted_96,
                                        _hoisted_97,
                                        _createVNode("td", null, [
                                          _createVNode("a", {
                                            target: "_blank",
                                            href: _ctx.get_core_data.on_url
                                          }, "点击查看链接", 8, ["href"])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createVNode("tr", null, [
                                    _createVNode("td", null, _toDisplayString(_ctx.localProject != 32 ? 2 : 1), 1),
                                    _hoisted_98,
                                    _createVNode("td", null, [
                                      _createVNode("a", {
                                        target: "_blank",
                                        href: _ctx.get_core_data.off_url
                                      }, "点击查看链接", 8, ["href"])
                                    ])
                                  ])
                                ])
                              ])
                            ]),
                            (_ctx.get_core_data.scene_image?.length > 0)
                              ? (_openBlock(), _createBlock("div", _hoisted_99, [
                                  _hoisted_100,
                                  _createVNode("div", null, [
                                    _createVNode("ul", _hoisted_101, [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_core_data.scene_image.filter((v) =>
                            v.file_path.trim()
                          ), (item) => {
                                        return (_openBlock(), _createBlock("li", {
                                          key: item,
                                          style: {"list-style":"none","width":"33.3%","text-align":"center"}
                                        }, [
                                          _createVNode("table", _hoisted_102, [
                                            _createVNode("tr", null, [
                                              _createVNode("td", _hoisted_103, _toDisplayString(item.scene_chinese), 1)
                                            ]),
                                            _createVNode("tr", null, [
                                              _createVNode("td", _hoisted_104, [
                                                _createVNode("img", {
                                                  src: 
                                    item.file_path.replace(
                                      '/data/projects/gamerobot/gr_backend',
                                      ''
                                    )
                                  ,
                                                  style: {"height":"99%","width":"99%","padding":"5px 0"}
                                                }, null, 8, ["src"])
                                              ])
                                            ])
                                          ])
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ], 512)), [
                            [_directive_loading, _ctx.loading]
                          ])
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_dialog, {
                        width: "500px",
                        modelValue: _ctx.dialogTableVisible,
                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_ctx.dialogTableVisible = $event)),
                        title: "提示"
                      }, {
                        footer: _withId(() => [
                          _createVNode("span", _hoisted_105, [
                            _createVNode(_component_el_button, {
                              onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.dialogTableVisible = false))
                            }, {
                              default: _withId(() => [
                                _hoisted_106
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.labelBtn()))
                            }, {
                              default: _withId(() => [
                                _hoisted_107
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        default: _withId(() => [
                          _createVNode(_component_el_form, {
                            inline: true,
                            size: "mini"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_form_item, { label: "输入标记内容" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.label_input,
                                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.label_input = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode("div", _hoisted_108, [
                        _hoisted_109,
                        _createVNode(_component_el_card, null, {
                          default: _withId(() => [
                            (_ctx.localProject != 18)
                              ? (_openBlock(), _createBlock("div", _hoisted_110, [
                                  _hoisted_111,
                                  _hoisted_112,
                                  _hoisted_113,
                                  (_ctx.localProject !== 32)
                                    ? (_openBlock(), _createBlock("p", _hoisted_114, " ③使用GM 性能/性能综合开关三合一/Profiler文件记录_开/关，控制是否打开profiler测试。 "))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.localProject !== 32 && _ctx.localProject != 18)
                              ? (_openBlock(), _createBlock("div", _hoisted_115, [
                                  _hoisted_116,
                                  _hoisted_117
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode("div", _hoisted_118, [
                              _createVNode("div", _hoisted_119, _toDisplayString(_ctx.getNum(3)) + "、测试用例说明:用例为5v5 十真人用例，详情为: ", 1),
                              _hoisted_120,
                              _hoisted_121,
                              _hoisted_122,
                              (_ctx.localProject == 18)
                                ? (_openBlock(), _createBlock("div", _hoisted_123, [
                                    _hoisted_124,
                                    _hoisted_125,
                                    _hoisted_126,
                                    _hoisted_127,
                                    _hoisted_128,
                                    _hoisted_129
                                  ]))
                                : (_openBlock(), _createBlock("div", _hoisted_130, [
                                    _hoisted_131,
                                    _hoisted_132,
                                    _hoisted_133,
                                    _hoisted_134,
                                    _hoisted_135,
                                    _hoisted_136
                                  ])),
                              _hoisted_137,
                              _createVNode("div", null, [
                                _createVNode(_component_el_table, {
                                  data: _ctx.tableData,
                                  border: "",
                                  style: {"width":"100%"}
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_table_column, {
                                      prop: "date",
                                      label: "时间",
                                      width: "80"
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      prop: "name",
                                      label: "行为",
                                      width: "280"
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      prop: "address",
                                      width: "280",
                                      label: "iOS"
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["data"])
                              ])
                            ]),
                            _createVNode("div", null, [
                              _createVNode("div", _hoisted_138, _toDisplayString(_ctx.getNum(4)) + "、各机型配置: ", 1),
                              _createVNode("table", _hoisted_139, [
                                _createVNode("tbody", null, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.test_data, (item, index) => {
                                    return (_openBlock(), _createBlock("tr", {
                                      style: {"text-align":"left"},
                                      key: index
                                    }, [
                                      _createVNode("td", _hoisted_140, [
                                        (index == 0)
                                          ? (_openBlock(), _createBlock("span", _hoisted_141))
                                          : _createCommentVNode("", true),
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _createVNode("td", _hoisted_142, [
                                        (index == 0)
                                          ? (_openBlock(), _createBlock("span", _hoisted_143))
                                          : _createCommentVNode("", true),
                                        _createTextVNode(_toDisplayString(item.title), 1)
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ]),
                _hoisted_144
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})